import { render, staticRenderFns } from "./cusDrag.vue?vue&type=template&id=48c99f18&scoped=true"
import script from "./cusDrag.vue?vue&type=script&lang=js"
export * from "./cusDrag.vue?vue&type=script&lang=js"
import style0 from "./cusDrag.vue?vue&type=style&index=0&id=48c99f18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c99f18",
  null
  
)

export default component.exports